export default __webpack_public_path__ + "static/media/gstIcon.97407136.webp";